module Meevo.Plugins.Register {
    "use strict";
    export enum RebookStage {
        Criteria = 1,
        Results = 2,
        Success=3
    }
    export class RebookModalController {
        rebookCandidates;
        scanCandidateGroupIndex: number;
        scanCandidateGroupKeys: string[];
        scanCandidateGroups; 
        openingContainers: any[];
        resultsMessage: string;
        rebookStage: RebookStage = RebookStage.Criteria;
        hasBooked: boolean;
        servicesCriteria: any = { wildcardType: Model.FilterWildcardType.Contains };
        bookedAppointments: any[] = [];

        static $inject = [
            "meevo.components.common.DataService", 
            "items", 
            "rebookCandidatesInitial", 
            "$mdDialog", 
            "meevo.components.modal.ModalService",
            "$rootScope", 
            "meevo.plugins.register.RebookService", 
            "$scope", 
            "meevo.components.busy.BusyService",
            "AppointmentEditorService", 
            "$q",
            "fromRegister", 
            "restServer"];

        constructor(public dataService: Meevo.Components.BaseClasses.IDataService, 
            protected items: RebookItem[], 
            protected rebookCandidatesInitial: any,
            protected mdDialog: ng.material.IDialogService, 
            protected modalService: Meevo.Components.Modal.IModalService,
            protected $rootScope: angular.IRootScopeService, 
            protected rebookService, 
            protected $scope,
            private busyService: Meevo.Components.Busy.IBusyService, 
            private appointmentEditorService, 
            private $q,
            private fromRegister: boolean, 
            private restServer: any) {
            this.load();

            $scope.$on(Meevo.Components.Common.Messages.BOOK_APPOINTMENT_FOR_CLIENT, () => {
                this.hasBooked = true;
                delete this.scanCandidateGroups[this.scanCandidateGroupKeys[this.scanCandidateGroupIndex-1]];
                this.scanNext();
            });
        }


        load() {
            this.rebookCandidatesInitial.forEach((rebookCandidate) => {
                let itemGreatestDate : RebookItem;
                this.items.forEach((item: RebookItem) => {
                    if (item.service.id == rebookCandidate.serviceId && item.client.id == rebookCandidate.clientId) {
                        if (itemGreatestDate) {
                            if (moment(item.serviceDate).isAfter(moment(itemGreatestDate.serviceDate))) {
                                itemGreatestDate = item;
                            }
                        } else {
                            itemGreatestDate = item;
                        }
                    }
                });

                rebookCandidate.client = itemGreatestDate.client;
                rebookCandidate.service = itemGreatestDate.service;
                if (rebookCandidate.employeeId) {
                    rebookCandidate.employee = itemGreatestDate.employee;
                }
                rebookCandidate.startDate = moment(itemGreatestDate.serviceDate).startOf("day");
                this.numberOfWeeksChanged(rebookCandidate);
                rebookCandidate.maxScanStartDate = moment(rebookCandidate.startDate).add(99 * 7, "days").toDate();
                rebookCandidate.minScanStartDate = moment(rebookCandidate.startDate).add(1, "day").toDate();
                rebookCandidate.employeeCriteria = { showEmployeesOnly: true, includeSharedEmployee: true, serviceIdList: [rebookCandidate.serviceId] };
                rebookCandidate.isSelected = !rebookCandidate.nextAppointServiceDateTime;
                rebookCandidate.additionalServices = [];
            });
            this.rebookCandidates = this.rebookCandidatesInitial;
        }

        dateChanged(rebookCandidate) {
//            let dayDiff = moment(rebookCandidate.scanStartDate).diff(rebookCandidate.startDate, "days");
//
//            rebookCandidate.numberOfWeeks = Math.floor(dayDiff / 7);
        }

        numberOfWeeksChanged(rebookCandidate) {
            rebookCandidate.scanStartDate = moment(rebookCandidate.startDate).add(rebookCandidate.numberOfWeeks * 7, "days").toDate();
        }

        serviceChanged(rebookCandidate) {
            if (rebookCandidate.service) {
                this.dataService.customMethodData(`/api/appointmentservice/template`,
                        "post",
                        {
                            ServiceId: rebookCandidate.service.id,
                            EmployeeId: rebookCandidate.employee.id,
                            ServiceAddOnIds: null
                        })
                    .then(response => {
                        if (!response.data.employeePerformsService) {
                            (this.modalService.confirmHandler("MESSAGE_EMPLOYEE_IS_NOT_CONFIGURED_TO_PERFORM_SERVICE", 
                                Components.Modal.ModalTranslationModes.Translate, true).then((resp) => {
                                if (!resp) {
                                    rebookCandidate.employee = null;
                                }
                            }));
                        }
                    });
                rebookCandidate.employeeCriteria.serviceIdList = [rebookCandidate.service.id];
            } else {
                rebookCandidate.employeeCriteria.serviceIdList = undefined;
            }
        }

        employeeChanged(rebookCandidate) {
            if (rebookCandidate.employee && rebookCandidate.employee.id && rebookCandidate.employee.id.length > 0) {
                rebookCandidate.genderPreference = undefined;
            }
        }

        scan(isValid) {
            if (!isValid) {
                return;
            }

            this.scanCandidateGroups = _(this.rebookCandidates)
                .chain()
                .where({isSelected: true})
                .sortBy((rebookCandidate) => rebookCandidate.client.displayName)
                .sortBy((rebookCandidate) => rebookCandidate.scanStartDate)
                .groupBy((rebookCandidate) => rebookCandidate.clientId + moment(rebookCandidate.scanStartDate).format())
                .value();
            this.scanCandidateGroupKeys = Object.keys(this.scanCandidateGroups);
            this.scanCandidateGroupIndex = 0;
            if (this.scanCandidateGroupKeys.length > 0) {
                this.scanNext();
                this.rebookStage = RebookStage.Results;
            }
        }

        scanNext() {
            if (this.scanCandidateGroupIndex == this.scanCandidateGroupKeys.length) {
                this.rebookStage = RebookStage.Success;
            } else {
                let nextGroup = this.scanCandidateGroups[this.scanCandidateGroupKeys[this.scanCandidateGroupIndex++]];
                let additionalServicesList = nextGroup.map(candidate => candidate.additionalServices).flat();

                let serviceList: string;

                serviceList = _(nextGroup).map(nextGroupItem => {
                    return nextGroupItem.service.shortcut; 
                }).join(", ");

                if (additionalServicesList.length > 0) {
                    var additionalServicesShortcuts = additionalServicesList
                        .map(additionalService => additionalService.service.shortcut).join(", ");
                    serviceList = [serviceList, additionalServicesShortcuts].join(", ");
                }

                this.openingContainers = undefined;
                this.resultsMessage = `Scan results for ${nextGroup[0].client.displayName}: ${serviceList}`;
                this.busyService.start();
                var scanServices = this.getScanServices(nextGroup);
                if (additionalServicesList.length > 0) {
                    scanServices = _(scanServices).union(this.getScanServices(additionalServicesList));
                }
                this.dataService.customMethodData("/api/AppointmentBook/Opening/List", "post",
                    {
                        startDate: moment(nextGroup[0].scanStartDate).toDate(),
                        endDate: moment(nextGroup[0].scanStartDate).add(7, "days").toDate(),
                        daysToExclude: [],
                        scanDateType: Model.ScanDateTypeEnum.FirstAvailable,
                        scanTimeType: Model.ScanTimeTypeEnum.Anytime,
                        scanOrigin: Model.ScanOriginEnum.Default,
                        scanServices: scanServices
                    }).then((response) => {
                        
                    if (response.data.length > 0) {
                        this.openingContainers = response.data;
                        
                        } else {
                        this.openingContainers = [];
                    }
                }).finally(()=>this.busyService.stop());
            }
        }

        close() {
            if (this.hasBooked && this.rebookStage !== RebookStage.Success) {
                this.rebookStage = RebookStage.Success;
            } else {
                this.mdDialog.hide();
            }
        }

        bookAppointment(container: any, suppressWarnings: boolean = false) {
            var services = [];
            var payingClient = {
                id: container.serviceOpenings[0].clientId
            }
            let employee = {
                id: container.serviceOpenings[0].employeeId
            }
            $.each(container.serviceOpenings, function (index, serviceOpening) {
                let serviceEmployee = {
                    id: serviceOpening.employeeId
                }
                var service = {
                    client: payingClient,
                    employee: serviceEmployee,
                    serviceId: serviceOpening.serviceId,
                    id: serviceOpening.serviceId,
                    service: { id: serviceOpening.serviceId },
                    transitionState: Meevo.Model.AppointStateEnum.Booked,
                    finalState: Meevo.Model.AppointFinalStateEnum.None,
                    resource: undefined,
                    resourceId: serviceOpening.resourceId,
                    resourceUnitId: serviceOpening.resourceUnitId,
                    genderPreference: serviceOpening.genderPreference,
                    nonRequest: serviceOpening.nonRequest,
                    startDateTime: serviceOpening.date,
                    startTime: moment(serviceOpening.startTime).format(),
                    price: serviceOpening.price,
                    steps: (serviceOpening.customServiceStepTimings || []).map(step => {
                        return {
                            serviceStepId: step.serviceStepId,
                            durationInMinutes: step.minutes
                        }
                    })
                }

                services.push(service);
            });
            var data = {};
            
            data = {
                appointmentId: null,
                id: null,
                startTime: container.serviceOpenings[0].startTime,
                date: container.serviceOpenings[0].date,
                employee: employee,
                payingClient: payingClient,
                services: services,
                service: { id: container.serviceOpenings[0].serviceId },
                appointmentDate: container.serviceOpenings[0].date,
                isFromRebook: true,
                note: container.note,
                optInClientSelectionAfterActions: false
            };
            this.appointmentEditorService.newAppointment(data, (result) => this.newAppointmentCallback(result, container));
        }

        newAppointmentCallback(result: any, container: any) {
            if (result) {
                _(result.services).each(service => {
                    let client = _(this.rebookCandidates).where({ clientId: service.client.id });
                    let serviceParameters = _(container.serviceOpenings).where({ serviceId: service.serviceId });
                    this.bookedAppointments.push({
                        clientName: client[0].client.displayName,
                        serviceName: serviceParameters[0].serviceName,
                        serviceShortCut: serviceParameters[0].serviceShortCut,
                        appointmentBookedDate: serviceParameters[0].startTime,
                        employeeName: serviceParameters[0].employeeName
                    });
                });
            }
        }

        refineCriteria() {
            var rebookCandidatesCopy = _(Object.assign({}, this.rebookCandidates)).toArray();
            this.items = <RebookItem[]>_(this.rebookCandidates).map(candidate => {
                return {
                    client: candidate.client,
                    service: candidate.service,
                    employee: candidate.employee,
                    serviceDate: candidate.startDate,
                    appointmentServiceId: candidate.appointmentServiceId
                };
            });
            this.rebookService.getRebookCandidates(this.items).then(candidates => {
                this.rebookCandidatesInitial = candidates;
                this.load();
                this.rebookStage = RebookStage.Criteria;
                this.scanCandidateGroupKeys = undefined;
                this.rebookCandidates.forEach(candidate => {
                    var matchedPrevCandidate = rebookCandidatesCopy
                        .find(prevCandidate => prevCandidate.appointmentServiceId === candidate.appointmentServiceId);
                    if (matchedPrevCandidate) {
                        candidate.additionalServices = matchedPrevCandidate.additionalServices;
                        if (matchedPrevCandidate.genderPreference) {
                            candidate.genderPreference = matchedPrevCandidate.genderPreference;
                            this.genderPreferenceChanged(candidate);
                        }
                    }
                })
            });
        }

        manuallyBookAppointment() {
            let candidates = [];
            if (this.scanCandidateGroupKeys) {
                this.scanCandidateGroupKeys.forEach((key) => {
                    if (this.scanCandidateGroups.hasOwnProperty(key)) {
                        this.scanCandidateGroups[key].forEach((candidate) => {
                            candidates.push(candidate);
                        });
                    }
                });
            } else {
                candidates = _(this.rebookCandidates).where({ isSelected: true });
            }

            let appointmentServices = [];

            if (candidates.length == 0) {
                return;
            }

            let servicesNeedingTemplates = [];
            this.dataService.customMethodData("/api/ClientAppointmentServices/List", "post", {
                appointmentServiceIds: _(candidates).pluck("appointmentServiceId"),
                includeSteps: true,
                startDate: moment().subtract(1, 'years').toDate() // api requires startDate so just made it something significantly in the past
            })
            .then((response: any) => {
                candidates.forEach((candidate: any) => {
                    let matchingAppointmentService = _(response.data).findWhere({ id: candidate.appointmentServiceId, serviceId: candidate.service.id });
                    if (matchingAppointmentService) {
                        let appointmentService = jQuery.extend(true, {}, matchingAppointmentService);
                        this.buildManualAppointmentService(appointmentService, candidate);
                        appointmentServices.push(appointmentService);
                    } else {
                        servicesNeedingTemplates.push(candidate);
                    }
                });

                servicesNeedingTemplates = _(servicesNeedingTemplates.concat(candidates
                    .filter(candidate => candidate.additionalServices.length > 0)
                    .map(candidate => {
                        if (candidate.additionalServices.length > 0) {
                            return candidate.additionalServices;
                        }
                }))).flatten();

                var continueManualBooking = () => {
                    this.mdDialog.hide();
                    this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                        stateName: "appointmentBook",
                        stateParams: {
                            actionState: Meevo.Model.AppointmentBookState.RebookAppointment,
                            actionStatePayload: {
                                appointmentServices: appointmentServices
                            },
                            dates: [
                                moment(_(candidates).sortBy(candidate =>
                                {
                                    return candidate.scanStartDate;
                                })[0].scanStartDate).format()
                            ]
                        }
                    });
                }

                if (servicesNeedingTemplates.length < 1) {
                    continueManualBooking();
                    return;
                }

                this.fetchServiceTemplates(servicesNeedingTemplates, appointmentServices)
                    .then(() => continueManualBooking());
            });
        }

        buildManualAppointmentService(appointmentService, candidate)
        {
            appointmentService.serviceDisplayName = candidate.service.displayName;
            appointmentService.serviceShortcut = candidate.service.shortcut;
            appointmentService.clientDisplayName = candidate.client.displayName;
            appointmentService.clientId = candidate.client.id;
            appointmentService.employeeCode = candidate && candidate.employee ? candidate.employee.code : "";
            appointmentService.startDateTime = candidate.scanStartDate;
            appointmentService.clientType = Model.ClientTypeEnum.Client;
            appointmentService.bookingType = Model.BookingTypeEnum.Booked;
            appointmentService.employeeType = Model.EmployeeTypeEnum.Request;
            appointmentService.rebookingType = Model.ReBookingTypeEnum.Normal;
            appointmentService.appointmentConfirmState = Model.ConfirmStateEnum.Unconfirmed;
            appointmentService.finalState = Model.AppointFinalStateEnum.None;
            appointmentService.transitionState = Model.AppointStateEnum.Booked;
        }

        employeeGenderSearchExclusionList = [Meevo.Model.EmployeeGenderSearchEnum.RandomEmployee, Meevo.Model.EmployeeGenderSearchEnum.SpecificEmployee];
        addNewAdditionalService(rebookCandidate) {

            var newAdditionalService = {
                employee: rebookCandidate.employee,
                client: rebookCandidate.client,
                clientId: rebookCandidate.client.id,
                service: null,
                startDate: rebookCandidate.startDate,
                scanStartDate: rebookCandidate.scanStartDate,
                serviceDate: rebookCandidate.startDate,
                employeeCriteria: { showEmployeesOnly: true, includeSharedEmployee: true },
                serviceCriteria: { ...this.servicesCriteria, excludeIdList: [rebookCandidate.service.id], 
                                    employeeId: rebookCandidate.employee.id }
            }

            if (rebookCandidate.additionalServices.length > 0) {
                var lastAdditionalService = rebookCandidate.additionalServices[rebookCandidate.additionalServices.length - 1];
                if (!lastAdditionalService.employee || !lastAdditionalService.service) {
                    return;
                }
                newAdditionalService.employee = lastAdditionalService.employee;
                newAdditionalService.serviceCriteria.employeeId = lastAdditionalService.employee.id;
            }

            rebookCandidate.additionalServices.push(newAdditionalService);
        }

        genderPreferenceChanged(appointmentServiceCandidate) {
            this.dataService.getEnumList(Meevo.Model.EnumTypeEnum.EmployeeGenderSearchEnum).then((data: any) => {
                let selectedGenderPreference = _(data).findWhere( { id: appointmentServiceCandidate.genderPreference });
                if (selectedGenderPreference) {
                    appointmentServiceCandidate.employee = {
                        id: undefined,
                        displayName: selectedGenderPreference.displayName
                    };
                    appointmentServiceCandidate.serviceCriteria.employeeId = undefined;
                }
            });
        }

        checkForFutureAppointment(additionalService) {
            this.rebookService.getRebookCandidates([additionalService]).then(res => {
                if (!res || res.length < 1) {
                    additionalService.nextAppointServiceDateTime = undefined;
                    return;
                }
                additionalService.nextAppointServiceDateTime = res[0].nextAppointServiceDateTime;
            });
        }

        removeAdditionalService(rebookCandidate: any, index: number) {
            rebookCandidate.additionalServices.splice(index, 1);
        }

        fetchServiceTemplates(candidates, appointmentServices) {
            var serviceEmployeeClients = candidates.map(candidate => {
                return {
                    employeeId: candidate.employee.id,
                    serviceId: candidate.service.id,
                    clientId: candidate.client.id
                }
            });

            return this.dataService.customMethodData(`/api/appointmentservice/templatelist`, 'post', {
                employeeServiceClientIds: serviceEmployeeClients
            }).then(response => {
                candidates.forEach(candidate => {
                    let candidateEmployee = angular.isDefined(candidate.employee) && !Guid.empty.equals(new Guid(candidate.employee.id)) ? candidate.employee : { id: emptyGuid() };
                    let appointmentService = jQuery.extend(true, {}, _(response.data).findWhere({ employeeId: candidateEmployee.id, serviceId: candidate.service.id, clientId: candidate.client.id }));
                    this.buildManualAppointmentService(appointmentService, candidate);
                    if (_(appointmentService.steps).any((step) => step.durationInMinutes !== 0)) {
                        appointmentServices.push(appointmentService);
                    }
                });
            });
        }

        additionalServiceChanged(additionalService) {
            additionalService.employeeCriteria.serviceIdList = additionalService.service ? 
                [additionalService.service.id] : 
                undefined;
            additionalService.serviceCriteria.employeeId = additionalService.employee ? 
                additionalService.employee.id : 
                undefined;
            this.checkForFutureAppointment(additionalService);
        }

        private getScanServices(candidateServices) {
            return _(candidateServices)
                .map((candidateService) => {
                    return {
                        clientId: candidateService.clientId,
                        employeeId: candidateService.employee.id,
                        serviceId: candidateService.service.id,
                        employeeGenderSearchEnum: <Model.EmployeeGenderSearchEnum> candidateService.genderPreference || 
                            Model.EmployeeGenderSearchEnum.SpecificEmployee,
                        appointmentServiceId: candidateService.appointmentServiceId
                    }
                });
        }
    }

    angular.module("meevo.plugins.register")
        .controller("meevo.plugins.register.RebookModalController", RebookModalController);
}